<template>
  <div>
    <v-dialog v-model="claimboxDialog" persistent width="500px">
      <v-card class="overflow-hidden">
        <v-toolbar dense class="gradient-bg elevation-0 white--text">
          <v-toolbar-title>Claim Box</v-toolbar-title><v-spacer />
          <v-icon @click="close_dialog()" class="white--text mr-n3"
            >mdi-close</v-icon
          >
        </v-toolbar>
        <v-card-text>
          <div class="mt-5">
            <v-form ref="form">
              <v-text-field
                dense
                outlined
                label="Name"
                v-model="boxName"
                :rules="[(v) => !!v || 'required']"
              />
              <v-autocomplete
                label="Select Location *"
                v-model="filterlocation"
                :rules="[(v) => !!v || 'required']"
                :items="filterlocations"
                :search-input.sync="searchF"
                hide-no-data
                hide-selected
                hint="Start typing to Search"
                dense
                item-text="location_name"
                item-value="location_id"
                outlined
                return-object
              />
            </v-form>
          </div>
        </v-card-text>
        <div class="d-flex justify-end mb-3">
          <v-card-actions class="">
            <v-btn
              color="primary"
              class="white--text"
              :loading="loading"
              @click="claim_box()"
              small
              >Yes</v-btn
            >
          </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { GetLocation } from "@/mixins/GetLocationList.js";
import { API, graphqlOperation } from "aws-amplify";
import { ClaimBox } from "@/graphql/mutations.js";
export default {
  mixins: [GetLocation],
  components: {},
  props: {
    claimboxDialog: Boolean,
    boxData: Object,
  },
  data: () => ({
    configuration: "EMPLOYEE",
    loading: false,
    boxName: "",
    filterlocation: "",
    filterlocations: [],
    searchF: null,
  }),
  watch: {
    claimboxDialog: {
      async handler() {
        {
          if (this.claimboxDialog == true) {
            await this.GetLocation();
            await this.fetch_details();
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    fetch_details() {
      this.GetLocationitems.forEach((element) => {
        this.filterlocations.push({
          location_name: element.loc_name,
          location_id: element.loc_id,
        });
      });
    },
    close_dialog() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.$emit("clicked", 0);
    },
    async claim_box() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          let result = await API.graphql(
            graphqlOperation(ClaimBox, {
              input: {
                organisation_id:
                  this.$store.getters.get_org_details[0].organisation_id,
                location_id: this.filterlocation.location_id,
                location_name: this.filterlocation.location_name,
                box_id: this.boxData.box_id ,
                claimed_by:this.$store.getters.get_useremail,
                box_name: this.boxName,
              },
            })
          );
          // console.log(result);
          var response = JSON.parse(result.data.ClaimBox);
          this.loading = false;
          if (response.Status == "Success") {
            this.$emit("successMsg", response.Message);
            this.$refs.form.reset();
            this.$refs.form.resetValidation();
            this.loading = false;
          } else {
            this.$emit("errorMsg", response.Message);
            this.loading = false;
          }
        } catch (error) {
          console.log(error);
          this.$emit("errorMsg", error.errors[0].message);
          this.loading = false;
        }
      }
    },
  },
};
</script>